import React, { useEffect } from 'react';
import { useAuth } from './AuthContext';
import '../styles/appearance.css';

interface AppearanceProviderProps {
  children: React.ReactNode;
}

const AppearanceProvider: React.FC<AppearanceProviderProps> = ({ children }) => {
  const { user } = useAuth();

  useEffect(() => {
    if (user?.settings?.appearance) {
      const { compactMode, highContrast, reduceMotion } = user.settings.appearance;
      
      // Apply classes to document body
      const body = document.body;
      
      // Remove all appearance classes first
      body.classList.remove('compact-mode', 'high-contrast', 'reduce-motion');
      
      // Add active appearance classes
      if (compactMode) {
        body.classList.add('compact-mode');
      }
      
      if (highContrast) {
        body.classList.add('high-contrast');
      }
      
      if (reduceMotion) {
        body.classList.add('reduce-motion');
      }
    }
  }, [user]);

  return <>{children}</>;
};

export default AppearanceProvider;
